import React from 'react';

import {
  BaseOnboardingTemplate,
  LoadingOverlay
} from 'modules';

import { Typography } from '@mui/material';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { CreateSubscriptionInput } from 'generated/graphql';
import { CreditCardForm } from './CreditCardForm/CreditCardForm';
import * as dataService from './dataService';



const stripePromise = loadStripe(process.env['REACT_APP_STRIPE_PUBLIC_KEY'] ?? '');

export const OnboardingPaymentActivity: React.FC = () => {
  const [
    fnWrappedCreateSubscriptionMutation,
    createSubscriptionMutationTuple
  ] = dataService.useCreateSubscriptionMutation();
  const [loading, setLoading] = React.useState(false);



  return (
    <BaseOnboardingTemplate.FC
      stepperMode="payment"
      title="Payment"
      subtitle={
        <Typography>
          Now let's set up your payment information. You will first be onboarded onto a 7-day free trial and then be charged <b>$99.99 per year</b>.
        </Typography>
      }>

      <LoadingOverlay active={createSubscriptionMutationTuple.loading || loading} />

      <Elements stripe={stripePromise}>
        <CreditCardForm
          onChangeLoading={l => setLoading(l)}
          onCreate={async (args: CreateSubscriptionInput) => {
            const res = await fnWrappedCreateSubscriptionMutation(args);
            return {
              paymentIntentClientSecret: res.data?.createSubscription.paymentIntentClientSecret ?? '',
              setupIntentClientSecret: res.data?.createSubscription.setupIntentClientSecret ?? ''
            };
          }} />
      </Elements>
    </BaseOnboardingTemplate.FC>
  );
};
